import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = [
    "itemsContainer", "itemTemplate", "validityType",
    "monthsField", "exactDateField", "dateInput",
    "countrySelect", "shippingDisplay", "nhShippingDisplay"
  ]

  connect() {
    this.itemIndex = this.itemsContainerTarget.querySelectorAll('.coupon-batch-item').length
    this.toggleValidityFields()
    this.initializeDatePicker()
  }

  initializeDatePicker() {
    if (this.hasDateInputTarget) {
      flatpickr(this.dateInputTarget, {
        enableTime: false,
        locale: "fr",
        dateFormat: "d/m/Y",
        allowInput: true,
        altInput: false
      })
    }
  }

  addItem(event) {
    event.preventDefault()

    const template = this.itemTemplateTarget.innerHTML.replace(/NEW_RECORD/g, this.itemIndex)
    this.itemsContainerTarget.insertAdjacentHTML('beforeend', template)

    this.itemIndex++
  }

  removeItem(event) {
    event.preventDefault()

    const item = event.target.closest('.coupon-batch-item')
    const destroyInput = item.querySelector('input[name*="_destroy"]')

    if (destroyInput) {
      destroyInput.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
  }

  updatePrice(event) {
    const select = event.target
    const item = select.closest('.coupon-batch-item')
    this.recalculateRow(item)
  }

  updateCents(event) {
    const eurosInput = event.target
    const item = eurosInput.closest('.coupon-batch-item')
    const priceInput = item.querySelector('.price-input')

    const euros = parseFloat(eurosInput.value) || 0
    priceInput.value = Math.round(euros * 100)
  }

  updateCountry() {
    this.updateShippingDisplay()
    this.recalculateAllRows()
  }

  toggleValidityFields() {
    if (!this.hasValidityTypeTarget) return

    const validityType = this.validityTypeTarget.value

    if (validityType === 'months') {
      this.monthsFieldTarget.style.display = 'block'
      this.exactDateFieldTarget.style.display = 'none'
    } else {
      this.monthsFieldTarget.style.display = 'none'
      this.exactDateFieldTarget.style.display = 'block'
    }
  }

  // Private

  recalculateRow(item) {
    const select = item.querySelector('.product-select')
    const selectedOption = select.options[select.selectedIndex]
    const priceInput = item.querySelector('.price-input')
    const priceEurosInput = item.querySelector('.price-euros-input')

    if (!selectedOption || !selectedOption.dataset.price) return

    const productPriceCents = parseInt(selectedOption.dataset.price) || 0
    const kubeType = selectedOption.dataset.kubeType || ''
    const productQuantity = parseInt(selectedOption.dataset.quantity) || 1

    const shippingPerMonth = this.getShippingForKubeType(kubeType)
    const totalCents = productPriceCents + (shippingPerMonth * productQuantity)

    priceInput.value = totalCents
    priceEurosInput.value = (totalCents / 100).toFixed(2)
  }

  recalculateAllRows() {
    const items = this.itemsContainerTarget.querySelectorAll('.coupon-batch-item')
    items.forEach(item => {
      if (item.style.display === 'none') return
      const select = item.querySelector('.product-select')
      if (select && select.selectedIndex > 0) {
        this.recalculateRow(item)
      }
    })
  }

  getShippingForKubeType(kubeType) {
    if (!this.hasCountrySelectTarget) return 0

    const selected = this.countrySelectTarget.options[this.countrySelectTarget.selectedIndex]
    if (kubeType === 'nh') {
      return parseInt(selected.dataset.nhShipping) || 0
    }
    return parseInt(selected.dataset.shipping) || 0
  }

  updateShippingDisplay() {
    if (!this.hasCountrySelectTarget) return

    const selected = this.countrySelectTarget.options[this.countrySelectTarget.selectedIndex]

    if (this.hasShippingDisplayTarget) {
      const cents = parseInt(selected.dataset.shipping) || 0
      const formatted = (cents / 100).toFixed(2).replace('.', ',')
      this.shippingDisplayTarget.textContent = `${formatted} €`
    }

    if (this.hasNhShippingDisplayTarget) {
      const nhCents = parseInt(selected.dataset.nhShipping) || 0
      const nhFormatted = (nhCents / 100).toFixed(2).replace('.', ',')
      this.nhShippingDisplayTarget.textContent = `${nhFormatted} €`
    }
  }
}
